let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jrCgx")).then(() => parcelRequire('PJPe9'));